'use strict';
module.exports = require('./TreeTable.vue');